import { ShopCartArea } from "./styles";
import { CSSProperties, memo, useContext, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavbarContext } from "../../../hooks/UseNavbarContext";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { fetchCart } from "../../../store/slices/ActiveCartReducerSlice";
import { FormattedValue } from "../../formattedValue/FormattedValue";
import NavButtonCart from "../NavButtonCart";
import { UISkeleton } from "ui";

const DEFAULT_CART_SKELETON_WIDTH = 86;
const DEFAULT_CART_SKELETON_HEIGHT = 28;
const CREMA_CART_STYLE: CSSProperties = {
  border: "1px solid #DFE4EC",
  borderRadius: 14,
  gap: 10,
  alignItems: "center",
  backgroundColor: "#FFFFFF",
  padding: "2px 12px 2px 2px",
  minHeight: 50,
};

export const CartBlock = memo(() => {
  const location = useLocation();
  const { navbarBadgeTrigger } = useContext(NavbarContext);
  const navButtonCartRef = useRef(null);
  const dispatch = useAppDispatch();
  const { activeCartData, isCartLoading } = useAppSelector((state) => state.activeCart);
  const shouldRenderSkeleton = isCartLoading || !activeCartData;

  useEffect(() => {
    dispatch(fetchCart());
  }, [dispatch, navbarBadgeTrigger, location.pathname]);

  return (
    <ShopCartArea className="cart-block-root cremaNavbar__cart" style={CREMA_CART_STYLE}>
      <div>
        <Link to="/cart" className="cremaNavbar__cartLink">
          <NavButtonCart ref={navButtonCartRef} />
        </Link>
      </div>

      <div>
        {shouldRenderSkeleton ? (
          <UISkeleton
            width={DEFAULT_CART_SKELETON_WIDTH}
            height={DEFAULT_CART_SKELETON_HEIGHT}
            sx={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
          />
        ) : (
          <b className="cart-block-amount cremaNavbar__cartAmount">
            <FormattedValue value={activeCartData.amount_with_vat} />{" "}
            {activeCartData.currency?.symbol || "€"}
          </b>
        )}
      </div>
    </ShopCartArea>
  );
});
